import { render, staticRenderFns } from "./student_applied_internships.vue?vue&type=template&id=79d3f191&scoped=true"
import script from "./student_applied_internships.vue?vue&type=script&lang=js"
export * from "./student_applied_internships.vue?vue&type=script&lang=js"
import style0 from "./student_applied_internships.vue?vue&type=style&index=0&id=79d3f191&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79d3f191",
  null
  
)

export default component.exports